import { useAtom } from "jotai";
import { useContextSelector } from "use-context-selector";
import Context from "../../../context/MainContext";
import { showCharacterIconsState } from "../../../global/state/global";
import RadioGroup from "../../1_atom/radio/radioGroup";
import ToggleWithDesc from "../../1_atom/toggles/toggleWithDesc";
import { SettingSection } from "./settingSection";

const AppearanceSettings = () => {
  const [showCharacterIcons, setShowCharacterIcons] = useAtom(showCharacterIconsState)

  const Theme = () => {
    const saveTheme = useContextSelector(Context, state => state.saveTheme);
    const theme = useContextSelector(Context, state => state.theme);

    return (
        <SettingSection title="Theme">
          <RadioGroup
            layout="vertical-list"
            data={{ id: "theme", mode: "free", onChange: saveTheme }}
            defaultValue={theme}
            options={[
              {
                label: "Theme follows OS",
                description:
                  "Theme will automatically update as your device theme preference changes.",
                value: "auto"
              },
              {
                label: "Dark mode",
                description: "Always dark mode.",
                value: "dark"
              },
              {
                label: "Light mode",
                description: "Always light mode.",
                value: "light"
              }
            ]}
          />
        </SettingSection>
    )
  }

  return (
    <>
      <Theme />
      <SettingSection title="Signup appearance">
        <ToggleWithDesc
          label="Show signup member character icons"
          description="For game classes & specs"
          defaultValue={typeof showCharacterIcons === "boolean" ? showCharacterIcons : true}
          callback={(state) => {
            setShowCharacterIcons(state)
          }}
        />
      </SettingSection>
    </>
  )
}

export default AppearanceSettings;